import classNames from "components/ui/classNames";
import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import { FormattedMessage } from "react-intl";

interface ExpandableParagraphProps {
  children: React.ReactNode;
  className?: string;
  maxHeightClassName?: string;
  expandable?: boolean;
}

export default function ExpandableParagraph({
  children,
  className,
  maxHeightClassName = "max-h-14",
  expandable = true,
}: ExpandableParagraphProps) {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0,
  });

  return (
    <div>
      <div
        style={
          !inView
            ? {
                WebkitMaskImage: "linear-gradient(to bottom, black calc(100% - 12px), transparent 100%)",
              }
            : {}
        }
      >
        <div
          className={classNames(
            "overflow-hidden bg-inherit text-justify text-sm text-gray-500",
            {
              "select-none": !expandable,
              [maxHeightClassName]: !showFullDescription,
            },
            className,
          )}
        >
          {children}
          <span ref={ref} />
        </div>
      </div>
      <div
        className={classNames("mt-1 flex w-full justify-center", {
          hidden: !expandable,
        })}
      >
        {(!inView || showFullDescription) && (
          <button
            type="button"
            onClick={() => setShowFullDescription((previous) => !previous)}
            className="text-xs text-blue-600 hover:underline"
          >
            {showFullDescription ? (
              <FormattedMessage defaultMessage="Esconder" id="PPsbyo" />
            ) : (
              <FormattedMessage defaultMessage="Ver tudo" id="3A7Ss9" />
            )}
          </button>
        )}
      </div>
    </div>
  );
}
